import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    rootGrid: {
        flexGrow: 1,
    },
	rootCard: {
		maxWidth: 400,
		height:555,
		margin:10,
		border: "4px outset grey"
	},	
	contentMedia:{
		height: 410,
		width: 350,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	media: {
		height: 640,
		width: 480,
	},	
	cardContent: {
		padding: '5px',
	},	
	cardButtons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	}
  }));
